import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import partsRow from "./Plugin/partsRowTable.vue";
import detailsTable from "./Plugin/detailsTable.vue"
import { domainName, processApi } from "../../../../utility/index"
import moment from "moment";

export default {
    components: { iTable, IPagination, partsRow, detailsTable },
    data() {
        return {
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                // repairType: '',
                MaintainTime: [],
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.search.whole')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            }, {
                value: '3',
                label: this.$t('common.customNum')
            },
            {
                value: '4',
                label: this.$t('common.manufactureNum')
            }],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "requestSerialNumber",
                    label: this.$t('VehicleManagement.serialNumber'),
                    align: "center",
                    width: "180px"
                },
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "150px"
                },
                {
                    prop: "customNum",
                    label: this.$t('common.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "carWorkTime",
                    label: this.$t('VehicleManagement.carWorkTime'),
                    align: "center",
                    width: "160px"

                },
                {
                    prop: "contactName",
                    label: this.$t('VehicleManagement.repairPerson'),
                    align: "center",
                    width: "120px"
                },

                {
                    prop: "happenTime",
                    label: this.$t('VehicleManagement.repairTime'),
                    align: "center",
                    width: "200px"
                },
                {
                    prop: "phone",
                    label: this.$t('VehicleManagement.phone'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "urgeCount",
                    label: this.$t('VehicleManagement.urgeCount'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "repairState",
                    label: this.$t('common.repairStatus'),
                    align: "center",
                    width: "120px",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.repairState === '' ? '' : params.row.repairState === 0 ? 'danger' : params.row.repairState === 1 ? 'warning' : params.row.repairState === 2 ? 'success' : 'info' }
                        }, params.row.repairState === '' ? '' : params.row.repairState === 0 ? this.$t('VehicleManagement.unaccepted') : params.row.repairState === 1 ? this.$t('VehicleManagement.repaired') : params.row.repairState === 2 ? this.$t('VehicleManagement.alreadyRepaired') : this.$t('VehicleManagement.closed'))
                    }

                }
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        isBtn: "REPAIRORDER_DETAIL",
                        method: (index, row) => {
                            // this.dialogOperateVisible = true
                            // this.serialNumber = row.serialNumber
                            // this.queryDetails(index, row)
                            this.$router.push({
                                path: '/VehicleManagement/RepairManagement/Details',
                                query: { requestSerialNumber: row.requestSerialNumber, tabName: 'second', sourcePage: 'maintain' }
                            })
                        }
                    }
                ],
            },
            // dialogOperateVisible: false,
            currentPage: 1,
            pageSize: 10,
            total: 1,
            dialogFormVisible: false,
            formLabelWidth: '100px',
            // diaTitle: '',
            btnType: '',
            rules: {
                carId: [
                    { required: true, message: this.$t('VehicleManagement.form.imputCarid'), trigger: 'blur' }
                ],
                operateUser: [
                    { required: true, message: this.$t('VehicleManagement.form.maintainPerson'), trigger: 'blur' }
                ],
                operateTime: [
                    { required: true, message: this.$t('VehicleManagement.form.maintainTime'), trigger: 'change' }
                ],
                repairType: [
                    { required: true, message: this.$t('VehicleManagement.form.chooseFaultItem'), trigger: 'change' }
                ],
            },
            form: {
                carId: '',
                userId: '',
                operateUser: '',
                operateTime: '',
                repairType: '1',
                remarks: '',
                peopleCost: '',
                materialCost: '',
                allCost: '',
                filePath: ''
            },
            selected: [],
            orgId: '',
            insertRepairMaterialDTOList: [],
            // OperateForm: {
            //     requestSerialNumber: '',
            //     carId: '',
            //     carWorkTime: '',
            //     operateUser: '',
            //     operateTime: '',
            //     repairType: '',
            //     remarks: '',
            //     peopleCost: '',
            //     materialCost: '',
            //     filePath: ''
            // },
            // FileOperateList: [],
            // dialogFileOperateVisible: false,
            // imageOperateUrl: '',
            // OperateLabelWidth: '126px',
            typeList: [],
            serialNumber: '',
            imageUrl: '',
            dialogVisible: false,
            processImg: processApi,
            FileList: [],
            filePath: '',
        }
    },
    computed: {
        materialCost() {
            this.form.allCost = Number(this.form.peopleCost) + Number(this.form.materialCost)
            return this.form.allCost
        },
    },
    watch: {
        materialCost(val) {
            this.form.allCost = val
        },
    },
    mounted() {
        this.getFaultType('query')
    },
    methods: {
        computedPrice(num) {
            console.log(num)
            this.form.materialCost = num
        },
        getMaintainList() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.MaintainTime) {
                if (this.formInline.MaintainTime.length > 0) {
                    startTime = this.formInline.MaintainTime[0]
                    endTime = this.formInline.MaintainTime[1]
                }
            }
            console.log(this.orgId)
            let param = {
                orgId: this.orgId,
                userId: sessionStorage.getItem("userId"),
                selectType: 1,
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                // repairType: this.formInline.repairType,
                startTime: startTime,
                endTime: endTime,
                repairSerialNumber: this.repairSerialNumber,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            console.log(param)
            this.$store.dispatch('RepairManagement/GET_GETREPAIRLIST', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        getFaultType(type) {
            this.$store.dispatch('DictionaryManaged/GET_SELECTMALFUNCTIONTYPE', {}).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.typeList = res.data.data
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getMaintainList()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                // repairType: '',
                MaintainTime: [],
            }
            this.getMaintainList()
        },
        addMaintain() {
            this.dialogFormVisible = true
            // this.diaTitle = this.$t('common.btn.add')
            // this.btnType = 'add'
            this.form.requestSerialNumber = this.selected[0].requestSerialNumber
            this.form.carId = this.selected[0].carId
            this.form.operateUser = sessionStorage.getItem("username")
            this.form.operateTime = moment().format("YYYY-MM-DD HH:mm:ss")
            this.form.repairType = ''
            this.form.filePath = ''
            this.FileList = []
            this.getFaultType('add')
            this.$nextTick(() => {
                this.$refs.diaTable.tableData = []
                this.$refs.form.resetFields()
            })
        },
        handlePictureCardPreview(file) {
            this.imageUrl = file.url;
            this.dialogVisible = true;
        },
        handleRemove(file, fileList) {
            this.FileList = []
            const arr = []
            fileList.map((item) => {
                this.FileList.push({
                    name: item.name,
                    url: item.url,
                    uid: item.uid
                })
                arr.push(item.url)
            })
            this.form.filePath = arr.join(',')
        },

        handleAvatarSuccess(res, file) {
            const arr = []
            this.FileList.push({
                url: res[0],
            })
            this.FileList.map(item => {
                arr.push(item.url)
            })
            this.form.filePath = arr.join(',')
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        userId: sessionStorage.getItem("userId"),
                        requestSerialNumber: this.form.requestSerialNumber,
                        carId: this.form.carId,
                        // userId: this.form.operateUser,
                        operateTime: this.form.operateTime,
                        repairType: this.form.repairType,
                        repairDescription: this.form.remarks,
                        peopleCost: this.form.peopleCost,
                        filePath: this.form.filePath,
                        repairContent: JSON.stringify(this.$refs.diaTable.tableData),
                        materialCost: this.form.materialCost
                    }
                    this.$store.dispatch('RepairManagement/GET_INSERTREPAIR', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.repairSuccess'))
                            this.dialogFormVisible = false;
                            this.getMaintainList();
                            this.closeDia();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })



                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                carId: '',
                operateUser: '',
                operateTime: '',
                repairType: '1',
                remarks: '',
                peopleCost: '',
                materialCost: '',
                filePath: ''
            }
            this.$nextTick(() => {
                this.$refs.diaTable.tableData = []
            })
        },
        closeDia() {
            this.form = {
                carId: '',
                operateUser: '',
                operateTime: '',
                repairType: '1',
                remarks: '',
                peopleCost: '',
                materialCost: '',
                filePath: ''
            }
            this.$nextTick(() => {
                this.$refs.diaTable.tableData = []
            })
            this.dialogFormVisible = false;
        },
        deleteMaintain() {
            this.$confirm(this.$t('common.AreYouSureWantGiveUpAcceptingOrder'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = { requestSerialNumber: this.selected[0].requestSerialNumber }
                    this.$store.dispatch('RepairManagement/GET_ABANDONREQUESTREPAIR', param).then(response => {
                        if (response.data.code == 200) {
                            this.getMaintainList()
                            this.$message.success(this.$t('common.abandonAcceptingOrders'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },
        // closeOperateDia() {
        //     this.dialogOperateVisible = false
        // },
        // queryDetails() {
        //     let param = {
        //         repairSerialNumber: this.serialNumber,
        //         pageNum: 1,
        //         pageSize: 10000,
        //     }
        //     this.$store.dispatch('MaintainManagement/GET_QUERYMAINTAINLIST', param).then(res => {
        //         if (res) {
        //             if (res.data.code == 200) {
        //                 this.$nextTick(() => {
        //                     this.OperateForm = {
        //                         requestSerialNumber: res.data.data.list[0].requestSerialNumber,
        //                         carId: res.data.data.list[0].carId,
        //                         carWorkTime: res.data.data.list[0].carWorkTime,
        //                         operateUser: res.data.data.list[0].operateUser,
        //                         operateTime: res.data.data.list[0].operateTime,
        //                         repairType: res.data.data.list[0].repairTypeStr,
        //                         remarks: res.data.data.list[0].remarks,
        //                         peopleCost: res.data.data.list[0].peopleCost,
        //                         materialCost: res.data.data.list[0].materialCost,
        //                         filePath: res.data.data.list[0].filePath
        //                     }
        //                     this.FileOperateList = [];
        //                     const arr = res.data.data.list[0].filePath.split(',')
        //                     arr.forEach(filePath => {
        //                         this.FileOperateList.push({
        //                             url: filePath,
        //                         });
        //                     });
        //                     this.$refs.detailTable.id = res.data.data.list.serialNumber
        //                     this.$refs.detailTable.getDetailList()
        //                 })
        //             }
        //         }
        //     }).catch(err => { })
        // },
        // handleOperatePictureCardPreview(file) {
        //     this.imageOperateUrl = file.url;
        //     this.dialogFileOperateVisible = true;
        // },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getMaintainList();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}